import { rebuildTree } from '@/helpers/functions';
import * as types from '../mutation-types'
import axios from '@/axios'

export default {
	namespaced: true,

	state: {
		accounts: [],
		accountsTree: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/accounts', { params: { withArchived: true } }).then((data) => {
				commit(types.STORE_ITEMS, data);
				return data
			})
		},
		fetchTree({ commit }, { withArchived }) {
			return axios.get('/accounts/descendants', { params: { withArchived } }).then((data) => {
				const tree = rebuildTree(data);
				commit(types.STORE_ITEMS_TREE, tree);
				return tree;
			})
		},

		fetchSuggestedNo({ commit }, { parentId }) {
			return axios.get('/accounts/generateAccountNo', { params: { parentAccountId: parentId } })
		},

		create({ commit }, { name, innerAccountingNo, parentId, accountType, notes, country, }) {
			return axios.post('/accounts', { name, innerAccountingNo, parentId, accountType, notes, country, });
		},

		update({ commit }, { id, name, innerAccountingNo, parentId, accountType, notes, country, }) {
			return axios.put(`/accounts/${id}`, { name, innerAccountingNo, parentId, accountType, notes, country, });
		},

		updateArchiveState({ commit }, { id, isArchived }) {
			return axios.put(`/accounts/${id}/status`, isArchived, { headers: { 'content-type': 'application/json' } });
		},

		delete({ commit }, { id }) {
			return axios.delete(`/accounts/${id}`);
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_ITEMS](state, accounts) {
			state.accounts = accounts;
		},
		[types.STORE_ITEMS_TREE](state, accountsTree) {
			state.accountsTree = accountsTree;
		},
		[types.RESET](state) {
			state.accounts = [];
			state.accountsTree = [];
		}
	},

	getters: {
		getAccountById: state => id => state.accounts.find(c => c.id === id),
	}
}